module.exports = __webpack_public_path__ + "static/img/logo.33001386.png";